<template>
  <v-container class="container-page">
    <v-card-text class="px-0 py-0">
      <v-card-title class="pt-0">
        <v-spacer></v-spacer>
        <v-btn color="info" small depressed class="mt-0" @click="processFile" right top>Processar Arquivo</v-btn>
        <v-flex xs12 sm5 md3>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
        </v-flex>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="serviceFiles"
        :search="search"
        class="table-transparent table-sticky"
      >
        <template v-slot:items="props">
          <tr :class="{'table--selected': recipientId === props.item.id}">
            <td class="checked-action" tabindex="0">
              <v-icon class="v-align-center mr-2" size="20px" v-if="recipientId === props.item.id">radio_button_checked</v-icon>
              <v-icon class="v-align-center mr-2" size="20px" v-else>radio_button_unchecked</v-icon>
            </td>
            <td class="">{{ props.item.fileName }}</td>
            <td class="">{{ $d(props.item.insertedAt.toDate(), 'long') }}</td>
            <td class="">{{ $t(props.item.state) }}</td>
          </tr>
        </template>
        <v-alert v-slot:no-results :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
      </v-data-table>
      <router-view />
    </v-card-text>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'RecipientMultipleIndex',
    data () {
      return {
        search: '',
        recipientId: null,
        headers: [
          { text: '', value: 'checked', class: 'checked-action', sortable: false },
          { text: 'Arquivo', value: 'fileName' },
          { text: 'Criado em', value: 'insertedAt' },
          { text: 'Status', value: 'state' }
        ]
      }
    },
    computed: {
      ...mapGetters({
        serviceFiles: 'serviceFiles/list'
      })
    },
    methods: {
      processFile () {
        this.$store.dispatch('global/processFile')
      }
    },
    beforeMount () {
      this.$store.dispatch('serviceFiles/getList')
    }
  }
</script>
